export default __webpack_public_path__ + "static/media/logo.56aa59c6.png";